export default __webpack_public_path__ + "static/media/bg.8f23376c.png";